import {
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonContent,
  IonText,
} from '@ionic/react';
import { personAddOutline } from 'ionicons/icons';
import { PlayerCard } from '../../components/PlayerCard';
import type { LineupSlotOccupant } from '../../services/LineupService';

// A fantasy team player, or a player with the score of a given match week
// (admin "11 de la jornada" editor).
interface SelectablePlayer extends LineupSlotOccupant {
  weekFantasyScore?: number;
}

interface PlayerSelectionModalProps<T extends SelectablePlayer> {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (fantasyTeamPlayer: T | null) => void;
  requiredRole: string;
  requiredRoleLabel: string;
  availablePlayers: T[];
  currentSelection: T | null;
  // Match week of the players' weekFantasyScore
  weekNumber?: number;
}

export const PlayerSelectionModal = <T extends SelectablePlayer>({
  isOpen,
  onClose,
  onSelect,
  requiredRole,
  requiredRoleLabel,
  availablePlayers,
  currentSelection,
  weekNumber,
}: PlayerSelectionModalProps<T>) => {
  const handleSelect = (fantasyTeamPlayer: T) => {
    onSelect(fantasyTeamPlayer);
    onClose();
  };

  const handleClear = () => {
    onSelect(null);
    onClose();
  };

  // Filter players by required role
  const filteredPlayers = availablePlayers.filter(
    (ftp) => ftp.player.role === requiredRole
  );

  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar>
          <IonTitle className="ml-4">Seleccionar {requiredRoleLabel}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onClose}>Cerrar</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        {currentSelection && (
          <div className="mb-4">
            <IonButton expand="block" fill="outline" onClick={handleClear}>
              Quitar jugador
            </IonButton>
          </div>
        )}

        {filteredPlayers.length === 0 ? (
          <IonText color="medium">
            <p className="text-center mt-8">
              No hay jugadores disponibles de tipo {requiredRoleLabel}
            </p>
          </IonText>
        ) : (
          <div className="space-y-2">
            {filteredPlayers.map((fantasyTeamPlayer) => (
              <PlayerCard
                key={fantasyTeamPlayer.id}
                player={fantasyTeamPlayer.player}
                weekNumber={weekNumber}
                weekFantasyScore={fantasyTeamPlayer.weekFantasyScore}
                footerActions={[
                  {
                    label: 'Seleccionar',
                    icon: personAddOutline,
                    onClick: () => handleSelect(fantasyTeamPlayer),
                  },
                ]}
              />
            ))}
          </div>
        )}
      </IonContent>
    </IonModal>
  );
};
